/**
 * BCG Favoriten – geräteübergreifend über Kunden-Metafeld (statt localStorage).
 * window.BCG_FAVORITES und window.BCG_FAVORITES_PROXY_URL werden von
 * snippets/favorites-data.liquid vor diesem Script gesetzt.
 */

function getFavorites() {
	return window.BCG_FAVORITES || [];
}

function setFavoritesLocal(favs) {
	window.BCG_FAVORITES = favs;
}

async function postToggle(payload) {
	const url = window.BCG_FAVORITES_PROXY_URL || '/apps/favoriten/toggle';
	const res = await fetch(url, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(payload),
	});
	if (!res.ok) {
		throw new Error('Favoriten-Server antwortet mit Fehler ' + res.status);
	}
	return res.json();
}

function showToast(msg) {
	let toast = document.getElementById('fav-toast');
	if (!toast) {
		toast = document.createElement('div');
		toast.id = 'fav-toast';
		toast.style.cssText =
			'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#111;color:#fff;padding:10px 20px;border-radius:8px;font-size:14px;z-index:9999;opacity:0;transition:opacity 0.3s;';
		document.body.appendChild(toast);
	}
	toast.textContent = msg;
	toast.style.opacity = '1';
	setTimeout(() => (toast.style.opacity = '0'), 2000);
}

async function toggleFavorite(btn) {
	const id = btn.dataset.productId;
	const title = btn.dataset.productTitle;
	const url = btn.dataset.productUrl;
	const image = btn.dataset.productImage;
	const price = btn.dataset.productPrice;
	const variantId = btn.dataset.variantId;
	const hasOnlyDefaultVariant = btn.dataset.hasOnlyDefaultVariant === 'true';
	const variantTitle = btn.dataset.variantTitle;

	let variants = [];
	try {
		variants = JSON.parse(btn.dataset.variants);
	} catch (e) {
		variants = [];
	}

	const favs = getFavorites();
	const alreadyFavorite = favs.some((f) => f.id === id);

	// Optimistisches UI-Update, damit der Klick sofort reagiert
	btn.disabled = true;
	if (alreadyFavorite) {
		btn.classList.remove('is-favorite');
	} else {
		btn.classList.add('is-favorite');
	}

	try {
		let result;
		if (alreadyFavorite) {
			result = await postToggle({ action: 'remove', id });
			showToast('Aus Favoriten entfernt');
		} else {
			const favorite = {
				id,
				title,
				url,
				image,
				price,
				variantId,
				hasOnlyDefaultVariant,
				variantTitle,
				variants,
			};
			result = await postToggle({ action: 'add', favorite });
			showToast('Zu Favoriten hinzugefügt ♥');
		}
		if (result && result.favorites) {
			setFavoritesLocal(result.favorites);
		}
	} catch (e) {
		// Bei Fehler UI-Änderung zurücknehmen
		if (alreadyFavorite) {
			btn.classList.add('is-favorite');
		} else {
			btn.classList.remove('is-favorite');
		}
		showToast('Fehler – bitte erneut versuchen');
	} finally {
		btn.disabled = false;
	}
}

async function removeFavorite(id) {
	try {
		const result = await postToggle({ action: 'remove', id });
		if (result && result.favorites) {
			setFavoritesLocal(result.favorites);
		}
		renderFavorites();
	} catch (e) {
		showToast('Fehler beim Entfernen');
	}
}

function changeQty(id, delta) {
	const input = document.getElementById(`qty-${id}`);
	let value = parseInt(input.value) + delta;
	if (value < 1) value = 1;
	input.value = value;
}

function addToCartFromFavorites(variantId, id, btn) {
	const qty = parseInt(document.getElementById(`qty-${id}`).value);
	btn.disabled = true;
	btn.textContent = 'Wird hinzugefügt...';

	fetch('/cart/add.js', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
			items: [{ id: variantId, quantity: qty }],
		}),
	})
		.then((response) => {
			if (!response.ok) throw new Error('Fehler beim Hinzufügen');
			return response.json();
		})
		.then(() => {
			return fetch('/cart.js')
				.then((res) => res.json())
				.then((cart) => {
					document.dispatchEvent(
						new CustomEvent('cart:update', {
							bubbles: true,
							detail: {
								data: {
									itemCount: cart.item_count,
									source: 'favorites-page',
								},
							},
						})
					);
				});
		})
		.then(() => {
			btn.textContent = 'In den Warenkorb legen';
			btn.disabled = false;
		})
		.catch(() => {
			showToast('Fehler beim Hinzufügen');
			btn.textContent = 'In den Warenkorb legen';
			btn.disabled = false;
		});
}

function addToCartFromFavoritesSelect(id, btn) {
	const variantId = document.getElementById(`variant-${id}`).value;
	addToCartFromFavorites(variantId, id, btn);
}

function renderFavorites() {
	const favs = getFavorites();
	const grid = document.getElementById('favorites-grid');
	const empty = document.getElementById('favorites-empty');
	if (!grid || !empty) return; // Nicht auf der Favoriten-Seite

	if (favs.length === 0) {
		grid.style.display = 'none';
		empty.style.display = 'flex';
		return;
	}

	grid.style.display = 'grid';
	empty.style.display = 'none';

	grid.innerHTML = favs
		.map((f) => {
			const actionHtml = f.hasOnlyDefaultVariant
				? `
				<div class="favorite-card__quantity">
					<button type="button" onclick="changeQty('${f.id}', -1)">−</button>
					<input type="number" id="qty-${f.id}" value="1" min="1" readonly>
					<button type="button" onclick="changeQty('${f.id}', 1)">+</button>
				</div>
				<button type="button" class="favorite-card__cta" onclick="addToCartFromFavorites('${f.variantId}', '${f.id}', this)">In den Warenkorb legen</button>
			`
				: `
				<select id="variant-${f.id}" class="favorite-card__select">
					${(f.variants || [])
						.map(
							(v) =>
								`<option value="${v.id}" ${String(v.id) === String(f.variantId) ? 'selected' : ''}>${v.title} – ${v.price}</option>`
						)
						.join('')}
				</select>
				<div class="favorite-card__quantity">
					<button type="button" onclick="changeQty('${f.id}', -1)">−</button>
					<input type="number" id="qty-${f.id}" value="1" min="1" readonly>
					<button type="button" onclick="changeQty('${f.id}', 1)">+</button>
				</div>
				<button type="button" class="favorite-card__cta" onclick="addToCartFromFavoritesSelect('${f.id}', this)">In den Warenkorb legen</button>
			`;

			const variantHtml =
				f.variantTitle && f.variantTitle !== 'Default Title' && f.hasOnlyDefaultVariant
					? `<p class="favorite-card__variant">${f.variantTitle}</p>`
					: '';

			return `
				<div class="favorite-card">
					<div class="favorite-card__cart-badge" data-cart-badge-product-id="${f.id}" aria-hidden="true">
						<svg width="14" height="14" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6" d="M3.392 6.875h13.216v8.016c0 .567-.224 1.112-.624 1.513-.4.402-.941.627-1.506.627H5.522a2.13 2.13 0 0 1-1.506-.627 2.15 2.15 0 0 1-.624-1.513zM8.818 2.969h2.333c.618 0 1.211.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.313c0-.622.246-1.218.683-1.658a2.33 2.33 0 0 1 1.65-.686"/></svg>
					</div>
					<a href="${f.url}" class="favorite-card__image-link">
						<img src="${f.image}" alt="${f.title}" class="favorite-card__image">
					</a>
					<button
						onclick="removeFavorite('${f.id}')"
						class="favorite-card__remove"
						title="Aus Favoriten entfernen"
					>✕</button>
					<div class="favorite-card__body">
						<a href="${f.url}" class="favorite-card__title">${f.title}</a>
						${variantHtml}
						<p class="favorite-card__price">${f.price}</p>
						${actionHtml}
					</div>
				</div>
			`;
		})
		.join('');

	if (window.BCGSyncCartBadges) {
		window.BCGSyncCartBadges();
	}
}

function initFavoriteButtons() {
	const favs = getFavorites();
	document.querySelectorAll('.favorite-toggle').forEach((btn) => {
		if (favs.find((f) => f.id === btn.dataset.productId)) {
			btn.classList.add('is-favorite');
		}
	});
}

document.addEventListener('DOMContentLoaded', function () {
	initFavoriteButtons();
	renderFavorites();
});

// Re-mark favorite buttons whenever new product cards are inserted into the
// page (e.g. collection filters/sorting re-rendered via Section Rendering
// API / DOM morph), since DOMContentLoaded only fires once on initial load.
const favoriteButtonObserver = new MutationObserver((mutations) => {
	const hasNewFavoriteButtons = mutations.some((mutation) =>
		Array.from(mutation.addedNodes).some(
			(node) =>
				node.nodeType === 1 &&
				(node.matches?.('.favorite-toggle') || node.querySelector?.('.favorite-toggle'))
		)
	);

	if (hasNewFavoriteButtons) initFavoriteButtons();
});

favoriteButtonObserver.observe(document.body, { childList: true, subtree: true });